var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": "9210",
                  "is-simple-query": false,
                  "custom-sim-query-placeholder":
                    _vm.$t("CargoMsg.Cargo_PlsInput") +
                    ":" +
                    _vm.$t("CargoMsg.Cargo_RouteProductName")
                },
                on: {
                  "click-more": function(value) {
                    _vm.isAdvancedQuery = value
                  },
                  simSearchItemCallBack: _vm.toSimpleQuery,
                  advSearchItemCallBack: _vm.queryHandler
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.addAirlineProductHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: !(
                            _vm.selectedRows && _vm.selectedRows.length > 0
                          ),
                          type: "success"
                        },
                        on: { click: _vm.editHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticStyle: { "flex-grow": "1", "min-height": "350px" } },
              [
                _c("cargo-ag-grid-wrapper", {
                  staticStyle: { height: "100%" },
                  attrs: {
                    "config-module": "202206071",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "show-selected-color": false,
                    "check-sub-record": false
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "202206071",
                    total: _vm.filter.total,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.fetchDataByPage
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm.airlineProductDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.airlineProductDialog.visible,
                title: _vm.airlineProductDialog.title,
                width: "1150px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.airlineProductDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "airline-product-form",
                  staticStyle: { display: "flex", "flex-wrap": "wrap" },
                  attrs: {
                    "label-width": _vm.$selectByLang("100px", "140px"),
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_RouteProductCode"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.airlineProductDialog.form.code,
                          callback: function($$v) {
                            _vm.$set(_vm.airlineProductDialog.form, "code", $$v)
                          },
                          expression: "airlineProductDialog.form.code"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_RouteProductName"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.airlineProductDialog.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.airlineProductDialog.form, "name", $$v)
                          },
                          expression: "airlineProductDialog.form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ServiceProduct"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        ref: "serviceProduct",
                        attrs: {
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_AirServiceProduct,
                          "callback-method-type": "value",
                          "default-value":
                            _vm.airlineProductDialog.form.serviceProduct,
                          "callback-params": { key: "serviceProduct" }
                        },
                        on: { parentCallBack: _vm.setSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Airline2"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "carrierId",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": {
                            airCmp: true,
                            companyLob: "airExport",
                            active: true
                          },
                          "default-value":
                            _vm.airlineProductDialog.form.carrierId || "",
                          headers: [
                            _vm.$t("Tool.ShortName"),
                            _vm.$t("Partners.chineseName")
                          ],
                          fields: ["shortName", "chineseName"],
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.airlineProductDialog.form.carrierId = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_PurchaseMethod"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        ref: "purchaseMethod",
                        attrs: {
                          "tag-value": "code",
                          "static-options":
                            _vm.SystemConstants.PURCHASE_METHODS,
                          "default-value":
                            _vm.airlineProductDialog.form.purchaseMethod
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.airlineProductDialog.form.purchaseMethod =
                              p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_PurchaseSource"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "purchaseSource",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": { active: true },
                          "default-value":
                            _vm.airlineProductDialog.form.purchaseSource || "",
                          headers: [
                            _vm.$t("Tool.ShortName"),
                            _vm.$t("Partners.chineseName")
                          ],
                          fields: ["shortName", "chineseName"],
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.airlineProductDialog.form.purchaseSource =
                              p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OriginPort"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        ref: "portOfDeparture",
                        staticStyle: { flex: "1" },
                        attrs: {
                          no: "portOfDeparture",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                          "default-value":
                            _vm.airlineProductDialog.form.portOfDeparture,
                          "tag-name": "englishName",
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.airlineProductDialog.form.portOfDeparture =
                              p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_RouteOfficer") } },
                    [
                      _c("cargo-multi-user-select", {
                        attrs: {
                          no: "airlineOperator",
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId
                          },
                          "default-multiple-value":
                            _vm.airlineProductDialog.form.airlineOperatorList ||
                            [],
                          placeholder: " "
                        },
                        on: { parentCallBack: _vm.airlineOperator }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_EffectiveDate"),
                        required: ""
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          no: "beginDate",
                          type: "date",
                          "picker-options": _vm.beginDatePickerOptions,
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.airlineProductDialog.form.beginDate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.airlineProductDialog.form,
                              "beginDate",
                              $$v
                            )
                          },
                          expression: "airlineProductDialog.form.beginDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_InvalidDate"),
                        required: ""
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          no: "endDate",
                          type: "date",
                          "picker-options": _vm.endDatePickerOptions,
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.airlineProductDialog.form.endDate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.airlineProductDialog.form,
                              "endDate",
                              $$v
                            )
                          },
                          expression: "airlineProductDialog.form.endDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { rows: 6, type: "textarea" },
                        model: {
                          value: _vm.airlineProductDialog.form.remarks,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.airlineProductDialog.form,
                              "remarks",
                              $$v
                            )
                          },
                          expression: "airlineProductDialog.form.remarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_IsEffective") } },
                    [
                      _c("el-checkbox", {
                        staticStyle: { width: "300px" },
                        attrs: { no: "active" },
                        model: {
                          value: _vm.airlineProductDialog.form.active,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.airlineProductDialog.form,
                              "active",
                              $$v
                            )
                          },
                          expression: "airlineProductDialog.form.active"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { height: "305px" } },
                [
                  _c(
                    "el-tabs",
                    {
                      staticStyle: { height: "100%" },
                      attrs: { type: "card" },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.airlineProductDialog.activeName,
                        callback: function($$v) {
                          _vm.$set(_vm.airlineProductDialog, "activeName", $$v)
                        },
                        expression: "airlineProductDialog.activeName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_VoyageNo"),
                            name: "airlineProductVoyage"
                          }
                        },
                        [
                          _c("airline-product-voyage", {
                            ref: "airlineProductVoyage",
                            attrs: {
                              "row-data": _vm.airlineProductDialog.form.voyages
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PrimeCost"),
                            name: "airlineProductVoyageCost"
                          }
                        },
                        [
                          _c("airline-product-voyage-cost", {
                            ref: "airlineProductVoyageCost",
                            attrs: { form: _vm.airlineProductDialog.form }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.commitHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.airlineProductDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }